























import { LoadingStatusType } from "@/enums/enums";
import { OnlineViewModel } from "@/model/document/documentModel";
import { ConvertToCustomizeIdList } from "@/service/document/customize/customizeFacade";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreDocument = namespace("Document");

@Component
export default class SelectDocumentType extends Vue {
  private selectDocumentType = { id: "", name: "" };
  private customizeIdList: Array<any> = [];
  private isHaveCustomize = false;

  @StoreDocument.Getter
  private getCustomizeIdList!: Array<any>;
  @StoreDocument.Getter
  private getDocumentDetail!: OnlineViewModel;
  @StoreDocument.Getter
  private getCustomizeIdListLoadingStatus!: LoadingStatusType;

  get isGetCustomizeIdListLoadingStatus() {
    return this.getCustomizeIdListLoadingStatus === LoadingStatusType.Loading;
  }

  @Watch("$i18n.locale")
  languageChanged() {
    if (this.isHaveCustomize && this.getCustomizeIdList && this.getCustomizeIdList.length > 0) {
      this.customizeIdList = ConvertToCustomizeIdList(
        this.getCustomizeIdList,
        this.getDocumentDetail?.transactionType,
        this.getDocumentDetail?.financeType,
        this.getDocumentDetail?.expenseType
      );
      this.SetDropdownDefault();
    }
  }

  @Watch("getCustomizeIdListLoadingStatus", { immediate: true })
  getCustomizeIdListLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      if (this.getCustomizeIdList && this.getCustomizeIdList.length > 0) {
        this.customizeIdList = this.getCustomizeIdList;
        this.SetDropdownDefault();
        this.isHaveCustomize = true;
      } else {
        this.isHaveCustomize = false;
      }
    }
  }

  public SetDropdownDefault() {
    let urlEcmi: any = this.$route.query.ecmi;
    const customizeId = urlEcmi ? urlEcmi.PeakDecryptionToString() : "";
    const customize = this.customizeIdList.find((x) => x.id == customizeId);
    if (customize) {
      this.selectDocumentType = customize;
    }
  }

  public SetLocationUrl(selectDocumentType: any) {
    const query = Object.assign({}, this.$route.query);
    if (query.ecmi) {
      delete query.ecmi;
      this.$router.replace({ query });
    }
    const link = window.location.href;
    if (selectDocumentType && selectDocumentType.id) {
      window.location.href = `${link}&ecmi=${selectDocumentType.id.PeakEncryption()}`;
    } else {
      window.location.href = link;
    }
  }
}
